import React, { useRef } from 'react';
import DataTable from '@components/common/CommonDataTable';
import { healtProviderPreviousDataColumnHeader } from '@constants/approvalConstants';

interface PreviousDetailsViewProps {
  facilityDetails?: any;
}

const PreviousDetailsView: React.FC<PreviousDetailsViewProps> = ({
  facilityDetails: _facilityDetails,
}) => {

  const columnHeader = useRef<any>(healtProviderPreviousDataColumnHeader);

  const healthProviderData =
    _facilityDetails && Array.isArray(_facilityDetails)
      ? _facilityDetails.map((item: any) => ({
        hfr_id: item.hfr_id,
        facility_name: item.facility_name,
        facility_type_name: item.facility_type_name,
        health_provider_name: Array.isArray(item.linked_healthprovider) 
          ? item.linked_healthprovider.map((hp: any) => `${hp.f_name || ''} ${hp.l_name || ''}`.trim()).join(', ') || 'N/A'
          : item.linked_healthprovider || 'N/A',
        mobiliser_name: Array.isArray(item.linked_mobiliser)
          ? item.linked_mobiliser.map((mb: any) => `${mb.f_name || ''} ${mb.l_name || ''}`.trim()).join(', ') || 'N/A'
          : item.linked_mobiliser || 'N/A',
        effective_dt: item.effective_from_dt,
        effective_to_dt: item.effective_to_dt || 'N/A',
      }))
      : [];


  return (
    <div className="previous-details-view">
      <div className="table-container">
        <DataTable
          data={healthProviderData}
          columnHeader={columnHeader.current}
          itemsPerPage={[10, 20, 30, 50]}
          searchTerm=""
          gridFor="healthProviderMaintenance"
          pagination={true}
        />
      </div>
    </div>
  );
};

export default PreviousDetailsView;
